"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VideoArea = exports.Root = exports.Inner = exports.Description = exports.ContentArea = exports.Caption = exports.ButtonWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationUtils = require("@ori/presentation-utils");
var _VideoLayout = require("../VideoLayout");
var _styles = require("../styles");
const Root = exports.Root = (0, _mui.styled)(_styles.OuterRoot, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'backgroundColor'
    ])
})((param)=>{
    let { backgroundColor } = param;
    return {
        background: backgroundColor
    };
});
const Caption = exports.Caption = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.text.primary,
        textTransform: 'uppercase',
        fontWeight: theme.typography.fontWeightBold,
        letterSpacing: '2.4px',
        fontSize: '1.2rem',
        marginBottom: 0,
        padding: theme.spacing(0, 3),
        display: '-webkit-box',
        WebkitLineClamp: 1,
        lineClamp: 1,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            padding: 0,
            marginBottom: theme.spacing(-1)
        }
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, renderOnMyPages } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4, 0),
        [theme.breakpoints.up('md')]: {
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 auto',
            gap: renderOnMyPages ? 0 : theme.spacing(0, 8),
            flexDirection: 'row',
            maxWidth: 1366,
            height: 700
        }
    };
});
const VideoArea = exports.VideoArea = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, alignment } = param;
    return {
        order: alignment === _editorialFetching.HorizontalContentAlignment.Right || alignment === _editorialFetching.HorizontalContentAlignment.Undefined ? 1 : 0,
        iframe: {
            aspectRatio: '9 / 16 !important',
            width: '100%',
            maxWidth: 330
        },
        margin: '0 auto',
        [".".concat(_VideoLayout.videoLayoutClasses.video)]: {
            maxHeight: 700,
            padding: theme.spacing(3, 0, 0),
            [theme.breakpoints.up('md')]: {
                padding: theme.spacing(8, 0)
            }
        },
        [".".concat(_VideoLayout.videoLayoutClasses.iframe)]: {
            padding: theme.spacing(3, 3, 0),
            [theme.breakpoints.up('md')]: {
                padding: theme.spacing(8, 8, 8, 0)
            }
        },
        [theme.breakpoints.up('md')]: {
            display: 'block',
            alignSelf: 'center',
            margin: 0
        }
    };
});
const ContentArea = exports.ContentArea = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, renderOnMyPages } = param;
    return {
        display: 'flex',
        order: 2,
        flexDirection: 'column',
        width: '100%',
        maxWidth: 'unset',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            order: 'unset',
            maxWidth: 583,
            gap: theme.spacing(3),
            margin: renderOnMyPages ? theme.spacing(0, 8) : 0
        }
    };
});
const Description = exports.Description = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        maxHeight: 320,
        padding: theme.spacing(0, 3),
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            padding: 0
        }
    };
});
const ButtonWrapper = exports.ButtonWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(2, 0, 0, 3),
        [theme.breakpoints.up('md')]: {
            margin: theme.spacing(3, 0, 0, 0)
        }
    };
});
